import type { HierarchyLevel } from '@/types/configurationV2'

interface BranchSelectorProps {
  belongsTo: HierarchyLevel | null
  onBelongsToChange: (level: HierarchyLevel | null) => void
  overrideNames: { contentId: number; contentName: string }[]
  activeBranch: number | 'default'
  onBranchChange: (branch: number | 'default') => void
  allowedLevels?: HierarchyLevel[]
}

const LEVEL_LABELS: Record<HierarchyLevel, string> = {
  product: 'Product',
  curriculum: 'Curriculum',
  course: 'Course',
  module: 'Module',
}

export default function BranchSelector({
  belongsTo,
  onBelongsToChange,
  overrideNames,
  activeBranch,
  onBranchChange,
  allowedLevels = ['product', 'curriculum', 'course', 'module'],
}: BranchSelectorProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-3">
        <span className="text-xs text-gray-500">소속레벨 분기:</span>
        <select
          value={belongsTo ?? ''}
          onChange={(e) => onBelongsToChange((e.target.value || null) as HierarchyLevel | null)}
          className="px-2 py-1 text-xs border border-gray-300 rounded-md"
        >
          <option value="">없음 (단일)</option>
          {allowedLevels.map((level) => (
            <option key={level} value={level}>
              {LEVEL_LABELS[level]} 기준
            </option>
          ))}
        </select>
      </div>

      {belongsTo && (
        <div className="flex gap-1">
          <button
            onClick={() => onBranchChange('default')}
            className={`px-3 py-1.5 text-xs rounded-md font-medium ${
              activeBranch === 'default'
                ? 'bg-emerald-500 text-white'
                : 'bg-emerald-100 text-emerald-700 hover:bg-emerald-200'
            }`}
          >
            Default
          </button>
          {overrideNames.map((item) => (
            <button
              key={item.contentId}
              onClick={() => onBranchChange(item.contentId)}
              className={`px-3 py-1.5 text-xs rounded-md ${
                activeBranch === item.contentId
                  ? 'bg-teal-500 text-white'
                  : 'bg-teal-100 text-teal-700 hover:bg-teal-200'
              }`}
            >
              {item.contentName}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
